// extracted by mini-css-extract-plugin
module.exports = {"CreateUnionFormHelperText":"CreateUnionForm_CreateUnionFormHelperText__1sGIK","CreateUnionForm":"CreateUnionForm_CreateUnionForm__1IyVI"};